import { Subject } from "../../../misc/api/apiTypes";
import { Device } from "../../../misc/api/DeviceLinkApi/Devices";
import * as P230In2itiveApi from '../../../misc/api/DeviceLinkApi/P230In2itive';
import { isIn2itiveError } from "../../../misc/api/DeviceLinkApi/P230In2itive";
import { AnotherSubjectAllocated, AnotherSubjectAllocatedOnDevice } from "../../../misc/api/DeviceLinkApi/P230In2itiveMessages";
import { isVcdModel, isVcdModelWithError } from "../../../misc/api/Vcd/Misc";

export const P230In2itiveEDiaryCheckExistingData = async (subjectToConfigure: Subject, device: Device, raiseConfigurationError: (message: string, isWarning: boolean) => void): Promise<boolean> => {
    try {
        const sessionResult = await P230In2itiveApi.GetSession(device.id);
        if (isIn2itiveError(sessionResult)) {
            if (sessionResult.error.message === "no data") {
                return false;
            }
        }

        if (isVcdModel(sessionResult) && sessionResult.eDiarySession.length > 0) {

            const subjectResult = await P230In2itiveApi.GetSubject(device.id);
            //if (subjectResult) {
            //    raiseConfigurationError(subjectResult.error.map(e => e.message).join("\n"), false);
            //    return false;
            //}

            //if (isVcdModel(subjectResult)) {
            //    if (subjectResult.subject[0]._id !== subjectToConfigure.Id) {
            //        raiseConfigurationError(AnotherSubjectAllocatedOnDevice(subjectResult.subject[0].number), true);
            //        return true;
            //    }

            //    return true;
            //}
        }
    } catch (err) {
        raiseConfigurationError(err, true);
    }
}
